import "./dateShow.css";
import { ReactComponent as CalendarIcon } from "../../assets/calendar.svg";

import { removeDashesFromString } from "../../util/removeDashesFromString";

const DateShow = ({ date }) => {
  // console.debug("INSIDE DateShow.jsx - date, typeof date: ", date, typeof date);
  return (
    <div className="dateContainer">
      <span>{removeDashesFromString(date)}</span>
    </div>
  );
};

export default DateShow;
